import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/feature/feature.query.gql"
import type {
  FeatureQuery,
  FeatureQueryVariables,
} from "@/v2-backoffice-client/feature/__types__/feature.query"

type Options = QueryHookOptions<FeatureQuery, FeatureQueryVariables>

export function useFeatureQuery(options?: Options) {
  return useQuery<FeatureQuery, FeatureQueryVariables>(query, options)
}
